<template>
  <q-page class="flex-center">
    <div class="q-pa-md ">
      <h2>Gerador de arquivo de remessa</h2>
      <br>
      <q-input outlined mask="##/##/####"
               v-model="form.data" label="Data de vencimento">

        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy ref="qDateProxy">
              <q-date v-model="form.data" mask="DD/MM/YYYY" @input="() => $refs.qDateProxy.hide()"/>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
      <br>
      <q-select
        label="Tipo de remessa"
        :options="types"
        map-options
        emit-value
        v-model="form.type"
        option-value="value"
        option-label="type"
      /><br><q-select
      label="Status de doador"
      :options="donators"
      map-options
      emit-value
      multiple
      v-model="form.donators"
      option-value="value"
      option-label="status"
      /><br>
      <div class="q-gutter-sm">
        <q-checkbox v-model="form.is_campangn" label="Para campanha?" />
      </div>
      <q-select
        v-if="form.is_campangn"
        label="Campanha"
        :options="campangns"
        map-options
        emit-value
        v-model="form.campangn"
        option-value="id"
        option-label="name"
      /><br>
      <q-input outlined   v-if="form.is_campangn"
               v-model="form.value" label="Valor da remessa"/>
      <br>
      <q-btn label="Gerar" @click="salvar" color="primary"/>
    </div>
    <q-inner-loading :showing="loading">
      <q-spinner-dots size="50px" color="primary"/>
    </q-inner-loading>
  </q-page>
</template>

<script>
import { CAMPANGNS_ALL, NEW_REMESSA } from '@/graphql/graphql'

export default {
  name: 'Remessas',
  data () {
    return {
      loading: false,
      campangns: {
        data: []
      },
      types: [
        { 'type': 'Boleto', 'value': 'B' },
        { 'type': 'Debito Itau', 'value': 'I' },
        { 'type': 'Debito Santander', 'value': 'S' }
      ],
      donators: [
      // 1 ativo, 2 atraso 2, 4 atraso 1, 9 inativo,
        { 'status': 'Ativo', 'value': '1' },
        { 'status': 'Atraso 1', 'value': '4' },
        { 'status': 'Atraso 2', 'value': '2' },
        { 'status': 'Inativo', 'value': '9' }
      ],
      form: {
        type: '',
        donators: [],
        campangn: [],
        is_campangn: false,
        data: '',
        value: 0
      }
    }
  },
  apollo: {
    campangns: {
      query: CAMPANGNS_ALL
      // pollInterval: 300, // ms
    }
  },
  methods: {
    salvar () {
      this.loading = true
      this.$apollo.mutate({
        mutation: NEW_REMESSA,
        variables: {
          type: this.form.type,
          date: this.form.data,
          value: this.form.value,
          campangn: this.form.campangn.length == 0 ? '' : this.form.campangn[0],
          donators: this.form.donators
        }
      }).then(result => {
        console.log(result)
        if (result.data.hasOwnProperty('newRemessa') && result.data.newRemessa === 'OK') {
          alert('Confira o arquivo de remessa no seu email!')
        } else {
          alert('Ocorreu um erro! Contate o administrador do sistema!')
        }
        this.loading = false
        // const data = result.data.login
        /* if (result.data.newEmailTemplate.hasOwnProperty('id')) {

          alert('Template de email Cadastrado')
        } */
      }).catch((error) => {
        console.error(error)
      })
    }
  }
}
</script>
